import { render, staticRenderFns } from "./employeeIndex.vue?vue&type=template&id=61b4b654&scoped=true"
import script from "./employeeIndex.vue?vue&type=script&lang=js"
export * from "./employeeIndex.vue?vue&type=script&lang=js"
import style0 from "./employeeIndex.vue?vue&type=style&index=0&id=61b4b654&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b4b654",
  null
  
)

export default component.exports